<router-outlet></router-outlet> <app-lang class="d-none" [flags]="false"></app-lang>

<!-- <div class="loader-active widget-loader" *ngIf="!loaded"></div> -->
@if (!loaded) {
  <app-page-loader class="app-tracker-loader"></app-page-loader>
}
